<template>
  <div style="overflow: hidden">
    <div class="wrapper">
      <div class="add_course_head">
        <div></div>
        <div>说播课比赛</div>
        <div class="add_course_head_save"></div>
      </div>
      <!-- <div style="position: absolute;width:200px;right:0;z-index:999999999">
            <el-input v-model="iframeSrc" placeholder="请输入内容" ></el-input>
        </div> -->

      <div class="content">
        <div class="content_box_head flex-row-space-between">
          <div class="content_search flex-row-v-center">
            <el-input placeholder="请输入名称" v-model="params.name" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="onSearch" style="border-radius: 50%"></el-button>
            </el-input>
          </div>
          <div>
            <el-select style="width: 150px" v-model="params.grade_id" placeholder="请选择年级" @change="searchGrade" clearable>
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select style="width: 150px" v-model="params.subject_code" placeholder="请选择学科" @change="searchSubject"
              clearable>
              <el-option v-for="item in subjectList2" :key="item.id" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select style="width: 150px" v-model="params.phase" placeholder="请选择参赛阶段" @change="searchPhase" clearable>
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex-row-center">
            <div class="course_creat_sort">
              <div>
                <el-popover placement="bottom" trigger="click" popper-class="area_popper_course"
                  v-model="popover_sort_show">
                  <div slot="reference" class="course_creat_sort_btn" style="cursor: pointer">
                    {{ sort_time }}-{{ sort_type }}
                    <i :class="popover_sort_show
                      ? 'el-icon-caret-top'
                      : 'el-icon-caret-bottom'
                      "></i>
                  </div>
                  <div class="course_creat_sort_options">
                    <div class="course_creat_sort_options_disable">
                      筛选排序
                    </div>
                    <div :class="{ color_active: sort_type == '时间最新' }" @click="change_sort_type('时间最新')">
                      时间最新
                    </div>
                    <div :class="{ color_active: sort_type == '时间最早' }" @click="change_sort_type('时间最早')">
                      时间最早
                    </div>
                    <div :class="{ color_active: sort_type == '投票最多' }" @click="change_sort_type('投票最多')">
                      投票最多
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
            <div class="creat_course" @click="add_material">上传</div>
            <download-excel class="export-excel-wrapper" :data="DetailsForm" :fields="json_fields" name="说播课比赛评委评分.xls">
              <!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
              <div class="creat_course">导出excel</div>
            </download-excel>
          </div>
        </div>

        <div class="course_list" v-if="videoList.length != 0">
          <div class="course_card teaching_card" v-for="(item, index) in videoList" :key="index">
            <div class="course_card_title">
              <div class="course_card_title_icon">
                <img src="../../assets/images/resource/视频.png" alt="" />
              </div>
              <div class="course_card_title_name" :title="item.name">
                {{ item.name }}
              </div>
              <div class="course_card_title_course_heat flex-row-v-center">
                <img src="../../assets/images/course_2.0/热度.png" alt="" /><span style="margin-left: 3px">{{
                  item.number_of_votes
                }}</span>
              </div>
            </div>
            <div class="course_card_content_item">
              参赛老师:{{ item.school_name }} - {{ item.people_name }}
            </div>
            <div class="course_card_content_item">
              年级学科:{{ item.grade_name }} - {{ item.subject_name }}
            </div>
            <div class="course_card_content_item">
              时间：{{ item.createtime | dataFormat }}
            </div>
            <!-- <div v-if="item.is_mark != 0" class="course_card_content_item">
              评分:{{ item.score }}分
              <span
                v-if="item.is_mark != 0"
                style="color: #69b4ff; cursor: pointer"
                @click="onScore(item, '查看')"
                >查看评分</span
              >
            </div> -->
            <div class="course_card_operation">
              <div class="course_card_operation_item" title="预览" @click="openVideo(item)">
                <img src="../../assets/images/course_2.0/player.png" alt="" />
              </div>
              <!-- <div class="course_card_operation_item" title="评分" v-if="userInfo.power == 10" @click="onScore(item)">
                <img src="../../assets/images/course_2.0/score.png" alt="" />
              </div> -->
              <!-- <div class="course_card_operation_item" title="评分"  @click="onScore(item)">
                <img src="../../assets/images/course_2.0/score.png" alt="" />
              </div> -->
              <div class="course_card_operation_item" title="查看备课包" @click="openCourse(item)" v-if="item.course_uuid">
                <img src="../../assets/images/course_2.0/查看.png" alt="" />
              </div>
              <div v-if="item.name.indexOf(userInfo.name) > -1 || item.teacher_uuid == userInfo.uuid"
                class="course_card_operation_item" title="编辑" @click="editVideo(item)">
                <img src="../../assets/images/course_2.0/editicon.png" alt="" />
              </div>
              <div v-if="userInfo.uuid == item.teacher_uuid" class="course_card_operation_item"
                @click.stop="del_topic(item, index)" title="删除">
                <img src="../../assets/images/course_2.0/删除.png" alt="" />
              </div>
              <div @click="onVote('1', item)" class="course_card_operation_item" title="投票" v-if="item.is_vote == 0">
                <img src="../../assets/images/course_2.0/nolike.png" alt="" />
              </div>
              <div @click="onVote('2', item)" class="course_card_operation_item" title="取消" v-if="item.is_vote == 1">
                <img src="../../assets/images/course_2.0/like.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无数据"></el-empty>
        <div style="text-align: right" v-if="listTotal">
          <el-pagination @current-change="handleCurrentChange" :current-page="params.page" :page-size="20" background
            layout="prev, pager, next" :total="listTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisible_add_material" custom-class="dialogVisible_add_material"
      width="50%" center :close-on-click-modal="false">
      <div class="add_material_contnet">
        <div>
          <div class="edit_material_item_type_name flex-row-v-center" style="margin-bottom: 20px">
            <div class="flex-row-v-center" style="width: 80px">
              <span style="color: red">*</span> 课题名称：
            </div>
            <el-input placeholder="请输入名称" style="width: 300px" v-model="name" clearable>
            </el-input>
          </div>

          <div>
            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="flex-row-v-center">
                <div class="felx-row-v-center" style="width: 80px">
                  <span style="color: red">*</span> 学校：
                </div>

                <el-select v-model="school_code" placeholder="请选择" style="width: 300px" @input="selectChangeParent">
                  <el-option v-for="(item, index) in school_list" :key="index" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="flex-row-v-center">
                <div class="felx-row-v-center" style="width: 80px">
                  <span style="color: red">*</span> 年级：
                </div>

                <el-select v-model="grade_id" placeholder="请选择" @change="selectGrade" style="width: 300px">
                  <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-row-v-center" style="margin-bottom: 20px" v-if="showSubject">
              <div class="felx-row-v-center" style="width: 80px">
                <span style="color: red">*</span> 学科：
              </div>
              <el-select v-model="subject_code" placeholder="请选择" style="width: 300px">
                <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </div>
            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="flex-row-v-center">
                <div class="felx-row-v-center" style="width: 80px">
                  <span style="color: red">*</span> 参赛老师：
                </div>
                <el-input placeholder="请输入参赛老师姓名" style="width: 300px" v-model="people_name" clearable>
                </el-input>
              </div>
            </div>
            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="flex-row-v-center">
                <div class="felx-row-v-center" style="width: 80px">
                  <span style="color: red">*</span> 参赛阶段：
                </div>

                <el-select v-model="phase" placeholder="请选择" style="width: 300px">
                  <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="flex-row-v-center">
                <div class="felx-row-v-center" style="width: 80px">
                  <span style="color: red">*</span> 决赛方式：
                </div>

                <el-select v-model="finals" placeholder="请选择" style="width: 300px">
                  <el-option v-for="item in finalsList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="flex-row-v-center" style="margin-bottom: 20px">
              <div class="felx-row-v-center" style="width: 80px">备课包：</div>
              <el-select v-model="course_uuid" placeholder="请选择备课包" filterable style="width: 300px">
                <el-option v-for="item in courseList" :key="item.course_uuid" :label="item.name"
                  :value="item.course_uuid">
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <div>
              <div class="add_material_content_head">上传说播课视频</div>
              <div class="add_material_content_des">
                文件类型仅限（mp4,avi, flv, wmv,mpg,swf）
              </div>
            </div>

            <uploader :options="options_add_material" class="uploader-example" @file-progress="onFileProgress"
              @file-added="onFileAdded" @file-success="onFileSuccess" ref="uploader">
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :attrs="options_add_material_attrs">选择文件</uploader-btn>
              </uploader-drop>
              <uploader-list>
                <ul class="file-list" slot-scope="props">
                  <li v-for="file in props.fileList" :key="file.id">
                    <uploader-file v-if="show_progress" :class="'file_' + file.id" ref="files" :file="file"
                      :list="true"></uploader-file>
                    <!-- <div>{{file}}</div> -->
                  </li>
                </ul>
              </uploader-list>
              <div style="opacity: 0">列表</div>
            </uploader>

            <!--  -->
            <div style="display: flex; flex-wrap: wrap">
              <div class="add_course_info_content_box_content_item" @click="prew_material(item_f)"
                v-for="(item_f, index_f) in add_material_list" :key="index_f + 'f'">
                <div class="
                    add_course_info_content_box_content_item_img
                    flex-center
                  ">
                  <div class="add_course_info_content_box_content_item_del" @click.stop="
                    $confirm('确认删除？')
                      .then((_) => {
                        add_material_list.splice(index_f, 1);
                      })
                      .catch((_) => { })
                    ">
                    <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
                  </div>
                  <img v-if="item_f.type == 'mp4' ||
                    item_f.type == 'MP4' ||
                    item_f.type == 'wmv' ||
                    item_f.type == 'WMV' ||
                    item_f.type == 'mpg' ||
                    item_f.type == 'MPG' ||
                    item_f.type == 'avi' ||
                    item_f.type == 'AVI' ||
                    item_f.type == 'swf' ||
                    item_f.type == 'SWF' ||
                    item_f.type == 'flv' ||
                    item_f.type == 'FLV'
                    " src="../../assets/images/course_2.0/视频.png" class="
                      add_course_info_content_box_content_item_img_homework
                    " alt="" />
                </div>
                <div class="add_course_info_content_box_content_item_txt">
                  {{ item_f.name || item_f.title || "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_add_material = false">取 消</el-button>
        <el-button type="primary" v-preventReClick :disabled="!showbtn" @click="onSave">
          确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="video_title" :visible.sync="dialogVisible_previewData" width="70%"
      custom-class="sign_course_edit_rich_guide_dia_prew" :before-close="handleClose">
      <iframe :src="video_url" frameborder="0" style="width: 100%; height: 60vh"></iframe>
    </el-dialog>

    <!-- 评分 -->
    <el-dialog :title="scoreTitle" :visible.sync="scoreDialogVisible" width="60%" center>
      <div class="listBox">
        <div class="listItem" v-for="(item, index) in explain" :key="index">
          <div class="listItemTitle">{{ item.title }}</div>
          <div class="listItemContent" v-if="item.score != 0">
            {{ item.content }}
          </div>
          <div v-if="item.score != 0">满分：{{ item.score }}</div>
          <div class="listItemFooter" v-if="item.score != 0">
            <el-slider v-model="item.scoreNum" show-input :format-tooltip="formatTooltip" :max="item.score"
              :disabled="scoreTitle.indexOf('查看') != -1">
            </el-slider>
          </div>
          <div v-if="item.score == 0">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.content"
              :disabled="scoreTitle.indexOf('查看') != -1">
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="scoreTitle.indexOf('查看') == -1">
        <el-button type="primary" @click="onSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "../../config/preventReclick"; //防多次点击，重复提交
import draggable from "vuedraggable";
import previewData from "../../components/common_module/preview_data.vue";
import { readSync } from "fs";
export default {
  components: { previewData, draggable, preventReClick },
  data() {
    return {
      DetailsForm: [],
      json_fields: {
        课题名称: "name",
        学校:"school_name",
        年级: "grade",
        学科: "subject",
        参赛老师: "people_name",
        参赛阶段:'phase_name',
        决赛方式:"finals_name",
        视频地址:"video_url",
        '1.说播设计-背景分析/教学目标/教学策略/教学资源/教学评价': "one",
        '2.说播活动-课堂组织/课堂训练/动态处理/实践指导/教学环境': "two",
        '3.说播效果-基础操作/目标达成/学习效度/展示评价': "three",
        '4.说播技术-平台应用/重难点突破/教学模式': "four",
        '5.说播素养-专业素养/教学素养/教师基本功': "five",
        '6.说播反思-成功点/问题点': "six",
        '7.评语': "seven",
        // '2.3说播活动-动态处理': "eight",
        // '2.4说播活动-实践指导': "nine",
        // '2.5说播活动-教学环境': "ten",
        // '3.1说播效果-基础操作': "eleven",
        // '3.2说播效果-目标达成': "twelve",
        // '3.3说播效果-学习效度': "thirteen",
        // '3.4说播效果-展示评价': "fourteen",
        // '4.1说播技术-平台应用': "fifteen",
        // '4.2说播技术-重难点突破': "sixteen",
        // '4.3说播技术-教学模式': "seventeen",
        // '5.1说播素养-专业素养': "eighteen",
        // '5.2说播素养-教学素养': "nineteen",
        // '5.3说播素养-基本功': "twenty",
        // '6.1说播反思-成功点': "twentyOne",
        // '6.2说播反思-问题点': "twentyTwo",
        // '7评委评语': "twentyThree",
      },
      scoreDialogVisible: false,
      scoreTitle: "评分",
      title: "上传说播课",
      video_title: "",
      course_uuid: "",
      popover_sort_show: false,
      sort_time: "全部",
      sort_type: "时间最新",
      dialogVisible_add_material: false,
      add_material_list: [],
      options_add_material: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: true,
        attrs: {
          accept: "*",
        },

        chunkSize: "1024000",
      },
      video_url: "",
      show_progress: false,
      options_add_material_attrs: { accept: ".mp4,.wmv,.avi,.flv,swf,mpg" },
      ispercentage: 0,
      name: "",
      gradeList: [],
      grade_id: "",
      subject_code: "",
      showSubject: false,
      showbtn: true,
      videoList: [],
      params: {
        page: 1,
        page_size: 20,
        name: "",
        sort: "createtime",
        order: "desc",
        grade_id: "",
        subject_code: "",
        phase: "",
        school_code: "",
      },
      subjectList2: [],
      listTotal: 0,
      dialogVisible_previewData: false,
      showSearchSubject: false,
      userInfo: "",
      courseList: [],
      editId: "",
      explain: [],
      mcc2_id: "",
      school_code: "",
      school_name: '',
      school_list: [],
      typeList: [{ label: '初赛', value: 1 },  { label: '复赛', value: 2 }, { label: '决赛', value: 3 }],
      finalsList:[{ label: '线下参赛', value: 1 },  { label: '线上参赛', value: 2 }],
      finals:1,
      phase: 1,
      people_name: "",
    };
  },
  filters: {
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input * 1000);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {
    this.options_add_material.target =
      "https://www.gaokaowin.com:8091/cloud/upload/zoneupload?convert_now=1";
  },

  beforeMount() { },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    this.school_code = this.userInfo.school_code;
    this.school_name = this.userInfo.school.name;
    console.log(this.userInfo)
    this.getGradeList();
    this.getList();
    this.getCourse();
    this.onExport();
    this.getSchoolList();
  },
  methods: {
    selectChangeParent(index) {
      for (let i in this.school_list) {
        if (index == this.school_list[i].code) {
          console.log(index)
          this.school_name = this.school_list[i].name;
        }
      }
    },
    onExport() {
      this.axios
        .post("/teacher/micro_course_competition3/getScored")
        .then((res) => {
          if (res.data.code == 1) {
            let list = res.data.data.scored;
            for (let i in list) {
              if (list[i].score_json) {
                let data = JSON.parse(list[i].score_json);
                list[i].one = data[0].scoreNum==0?'':data[0].scoreNum;
                list[i].two = data[1].scoreNum==0?'':data[0].scoreNum;
                list[i].three = data[2].scoreNum==0?'':data[0].scoreNum;
                list[i].four = data[3].scoreNum==0?'':data[0].scoreNum;
                list[i].five = data[4].scoreNum==0?'':data[0].scoreNum;
                list[i].six = data[5].scoreNum==0?'':data[0].scoreNum;
                // list[i].seven = data[6].scoreNum==0?'':data[0].scoreNum;
                // list[i].eight = data[7].scoreNum==0?'':data[0].scoreNum;
                // list[i].nine = data[8].scoreNum==0?'':data[0].scoreNum;
                // list[i].ten = data[9].scoreNum==0?'':data[0].scoreNum;
                // list[i].eleven = data[10].scoreNum==0?'':data[0].scoreNum;
                // list[i].twelve = data[11].scoreNum==0?'':data[0].scoreNum;
                // list[i].thirteen = data[12].scoreNum==0?'':data[0].scoreNum;
                // list[i].fourteen = data[13].scoreNum==0?'':data[0].scoreNum;
                // list[i].fifteen = data[14].scoreNum==0?'':data[0].scoreNum;
                // list[i].sixteen = data[15].scoreNum==0?'':data[0].scoreNum;
                // list[i].seventeen = data[16].scoreNum==0?'':data[0].scoreNum;
                // list[i].eighteen = data[17].scoreNum==0?'':data[0].scoreNum;
                // list[i].nineteen = data[18].scoreNum==0?'':data[0].scoreNum;
                // list[i].twenty = data[19].scoreNum==0?'':data[0].scoreNum;
                // list[i].twentyOne = data[20].scoreNum==0?'':data[0].scoreNum;
                // list[i].twentyTwo = data[21].scoreNum==0?'':data[0].scoreNum;
                list[i].seven = data[22].content;
              } else {
                list[i].one = '';
                list[i].two = '';
                list[i].three = '';
                list[i].four = '';
                list[i].five = '';
                list[i].six = '';
                list[i].seven = '';
                // list[i].eight = '';
                // list[i].nine = '';
                // list[i].ten = '';
                // list[i].eleven = '';
                // list[i].twelve = '';
                // list[i].thirteen = '';
                // list[i].fourteen = '';
                // list[i].fifteen = '';
                // list[i].sixteen = '';
                // list[i].seventeen = '';
                // list[i].eighteen = '';
                // list[i].nineteen = '';
                // list[i].twenty = '';
                // list[i].twentyOne = '';
                // list[i].twentyTwo = '';
                // list[i].twentyThree = '';
              }
            }
            this.DetailsForm = list;
          }
        });
    },
    formatTooltip(val) {
      return Math.floor(val);
    },
    //获取学校列表
    getSchoolList() {
      this.axios.get('https://www.gaokaowin.com/teacher/subject/getSchool').then(res => {
        if (res.data.code == 1) {
          this.school_list = res.data.data;
          console.log(this.school_list)
        }
      })
    },

    //打分
    onSubmit() {
      let params = {
        mcc2_id: this.mcc2_id,
        score: "",
        score_json: JSON.stringify(this.explain),
      };
      console.log(this.explain);
      let score = 0;
      this.explain.forEach((item) => {
        score = score + item.scoreNum;
      });
      params.score = score;
      console.log(params);
      this.axios
        .post("/teacher/micro_course_competition3/mark", params)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "提交成功",
              type: "success",
              duration: 1500,
              showClose: true,
            });
            this.scoreDialogVisible = false;
            this.getList();
            this.onExport();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    //评分
    onScore(item, data) {
      if (data) {
        this.scoreTitle = `查看评分-${item.name}(${item.teacher_name})`;
      } else {
        this.scoreTitle = `评分-${item.name}(${item.teacher_name})`;
      }

      let params = {
        mcc2_id: item.id,
      };
      this.mcc2_id = item.id;
      this.axios
        .post("/teacher/micro_course_competition3/getScored", params)
        .then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            if (!res.data.data.scored) {
              this.explain = res.data.data.explain;
              this.explain.forEach((item) => {
                item.scoreNum = 0;
              });
            } else {
              this.explain = JSON.parse(res.data.data.scored.score_json);
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: 1500,
              showClose: true,
            });
          }
        });
      this.scoreDialogVisible = true;
    },
    openCourse(item) {
      sessionStorage.removeItem("content_json");
      sessionStorage.removeItem("teaching_text_e");
      sessionStorage.removeItem("course_content_course_name");

      sessionStorage.removeItem("teaching_text_name_e");
      sessionStorage.removeItem("teaching_text_name");
      sessionStorage.removeItem("guidance_text_e");
      sessionStorage.removeItem("guidance_text");
      sessionStorage.removeItem("teaching_text");
      sessionStorage.removeItem("guidance_text_uuid");
      sessionStorage.removeItem("teaching_text");
      sessionStorage.removeItem("course_content");
      sessionStorage.removeItem("course_content_guide_name");
      sessionStorage.removeItem("course_content_guide_json");
      sessionStorage.removeItem("course_content_type");
      sessionStorage.course_add_type = "edit";
      console.log(item);
      sessionStorage.course_new_courseId = item.course_uuid;
      sessionStorage.server_url = item.server_url;
      this.$router.push({
        path: "/course/sign_course_new?from=videotapeCompetition",
        query: { name: "预览" },
      });
    },
    getCourse() {
      let params = {
        flag: "my_course",
        current_page: 1,
        page_size: 9999,
      };
      this.axios.post("/school/bag/sourceBag", params).then((res) => {
        if (res.data.code == 1) {
          this.courseList = res.data.data.data;
        }
      });
    },
    editVideo(item) {
      console.log(item);
      this.title = "编辑说播课";
      this.editId = item.id;
      this.grade_id = item.grade_id;
      this.subject_code = item.subject_code;
      this.school_code = item.school_code;
      this.school_name = item.school_name;
      this.phase = item.phase;
      this.finals = item.finals;
      this.people_name = item.people_name;
      this.name = item.name;
      this.course_uuid = item.course_uuid;
      this.getSubjectList();
      this.add_material_list = [{ url: item.video_url, type: "mp4" }];
      this.dialogVisible_add_material = true;
    },
    handleClose() {
      this.video_url = "";
      this.dialogVisible_previewData = false;
    },
    onSearch() {
      this.params.page = 1;
      console.log(111)
      this.getList();
    },
    //删除录像课视频
    del_topic(item) {
      this.$confirm("此操作将删除比赛视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: item.id,
        };
        this.axios
          .post("/teacher/micro_course_competition3/del", params)
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.params.page = 1;
              this.getList();
              this.onExport();
            }
          });
      });
    },
    //获取说播课视频列表
    getList() {
      this.axios
        .post("/teacher/micro_course_competition3/getList", this.params)
        .then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            this.videoList = res.data.data.list;
            this.listTotal = res.data.data.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getList();

    },

    //获取年级
    getGradeList() {
      this.axios.get("/teacher/subject/getgrads").then((res) => {
        if (res.data.code == 1) {
          this.gradeList = res.data.data;
        }
      });
    },
    //选中年级
    selectGrade() {
      this.subject_code = "";
      this.showSubject = false;
      this.getSubjectList();
    },
    searchGrade() {
      this.params.subject_code = "";
      this.showSearchSubject = false;
      this.getSubjectList2();
      this.params.page = 1;
      this.getList();
    },
    searchPhase() {
      this.params.page = 1;
      this.getList();
    },
    searchSubject() {
      this.params.page = 1;
      this.getList();
    },
    //获取对应年级的学科
    getSubjectList2() {
      this.axios
        .get(
          `/teacher/subject/getsubject?grade_id=${parseInt(this.params.grade_id / 10) * 10
          }`
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.subjectList2 = res.data.data;
            this.showSearchSubject = true;
          }
        });
    },
    //获取对应年级的学科
    getSubjectList() {
      this.axios
        .get(
          `/teacher/subject/getsubject?grade_id=${parseInt(this.grade_id / 10) * 10
          }`
        )
        .then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            this.subjectList = res.data.data;
            this.showSubject = true;
          }
        });
    },
    btnsearch() { },
    change_sort_type(type) {
      this.popover_sort_show = false;
      this.sort_type = type;
      this.params.page = 1;

      if (type == "时间最新") {
        this.params.sort = "createtime";
        this.params.order = "desc";
      }
      if (type == "时间最早") {
        console.log("====");
        this.params.sort = "createtime";
        this.params.order = "asc";
      }
      if (type == "投票最多") {
        this.params.sort = "number_of_votes";
        this.params.order = "desc";
      }
      //this.sort_getdata();
      console.log("-----");
      this.getList();
    },

    add_material() {
      this.name = "";
      this.grade_id = "";
      this.subject_code = "";
      this.add_material_list = [];
      this.course_uuid = "";
      this.showSubject = false;
      this.title = "上传说播课";
      this.dialogVisible_add_material = true;
    },
    onFileProgress(rootFile, file, chunk) {
      if (Math.floor((chunk.startByte / file.size) * 100) > this.ispercentage) {
        this.ispercentage = Math.floor((chunk.startByte / file.size) * 100);
        console.log(this.ispercentage);
      }
    },
    onFileAdded(file) {
      // console.log(file)
      this.showbtn = false;
      this.add_material_list = [];
      this.ispercentage = 0;
      if (
        file.fileType.indexOf("mp4") == -1 &&
        file.fileType.indexOf("avi") == -1 &&
        file.fileType.indexOf("MP4") == -1 &&
        file.fileType.indexOf("AVI") == -1 &&
        file.fileType.indexOf("flv") == -1 &&
        file.fileType.indexOf("FLV") == -1 &&
        file.fileType.indexOf("swf") == -1 &&
        file.fileType.indexOf("SWF") == -1 &&
        file.fileType.indexOf("mpg") == -1 &&
        file.fileType.indexOf("MPG") == -1 &&
        file.fileType.indexOf("wmv") == -1 &&
        file.fileType.indexOf("WMV") == -1 &&
        file.name.indexOf("flv") == -1 &&
        file.name.indexOf("FLV") == -1
      ) {
        file.pause();
        this.$message({
          duration: 3000,
          type: "error",
          message: "文件类型仅限（mp4,avi,flv,swf,mpg,wmv）!",
        });
        return;
      }

      this.show_progress = true;
    },
    onFileSuccess(rootFile, file, response, chunk) {
      this.ispercentage = 100;

      if (JSON.parse(response).code == 1) {
        // console.log(file.name);

        // console.log(response);

        try {
          this.upFile_src = JSON.parse(response).data;
        } catch (error) {
          this.upFile_src = response;
        }
        this.upFile_type =
          file.name.split(".")[file.name.split(".").length - 1];
        this.ispercentage = 0;
        this.showbtn = true;
        let arr = [];
        arr.push({
          name: file.name,
          url: this.upFile_src,
          type: file.name.split(".")[file.name.split(".").length - 1],
          id: file.id,
        });
        this.add_material_list = arr;
        this.show_progress = false;
      } else {
        this.showbtn = true;
        // file-removed(file)
        this.$message({
          type: "error",
          message: JSON.parse(response).msg,
          duration: 1500,
          showClose: true,
        });
      }
    },

    //提交
    onSave() {
      if (!this.name) {
        this.$message({
          message: "说播课名称不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.people_name) {
        this.$message({
          message: "参赛老师姓名不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.grade_id) {
        this.$message({
          message: "年级不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.subject_code) {
        this.$message({
          message: "学科不能为空",
          type: "warning",
        });
        return;
      }
      if (
        this.add_material_list.length == 0 ||
        !this.add_material_list[0].url
      ) {
        this.$message({
          message: "上传说播课视频不能为空",
          type: "warning",
        });
        return;
      }
      let params = {
        grade_id: this.grade_id,
        name: this.name,
        video_url: this.add_material_list[0].url,
        subject_code: this.subject_code,
        course_uuid: this.course_uuid,
        server_url: this.userInfo.school.server_url,
        phase: this.phase,
        finals:this.finals,
        people_name: this.people_name,
        school_code: this.school_code,
        school_name: this.school_name,
      };
      if (this.title == "上传说播课") {
        this.axios
          .post("/teacher/micro_course_competition3/add", params)
          .then((res) => {
            if (res.data.code == 1) {
              this.grade_id = "";
              this.subject_code = "";
              this.add_material_list = [];
              this.showSubject = false;
              this.dialogVisible_add_material = false;
              this.params.page = 1;
              this.params.name = "";
              this.params.phase = "";
              this.people_name = '';
              this.getList();
              this.onExport();
              this.$message({
                message: "上传成功",
                type: "success",
              });
            }
          });
      } else {
        params.id = this.editId;
        this.axios
          .post("/teacher/micro_course_competition3/edit", params)
          .then((res) => {
            if (res.data.code == 1) {
              this.grade_id = "";
              this.subject_code = "";
              this.add_material_list = [];
              this.showSubject = false;
              this.dialogVisible_add_material = false;
              this.params.page = 1;
              this.params.name = "";
              this.params.phase = "";

              this.people_name = '';
              this.getList();
              this.onExport();
              this.$message({
                message: "上传成功",
                type: "success",
              });
            }
          });
      }
    },
    //预览视频
    openVideo(item) {
      this.video_title = item.name;
      this.video_url = item.video_url;
      this.dialogVisible_previewData = true;
    },
    onVote(type, item) {
      let params = {
        status: type,
        mcc_id: item.id,
      };
      this.axios
        .post("/teacher/micro_course_competition3/vote", params)
        .then((res) => {
          if (res.data.code == 1) {
            if (type == 1) {
              this.$message({
                message: "投票成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            }
          }
          this.getList();
        });
    },
  },
};
</script>
<style ></style>
<style scoped>
.wrapper {
  margin: 14px auto;
  /* background: #ffffff; */
  height: calc(100vh - 152px);
  overflow: auto;
  border-radius: 12px;
  overflow: hidden;
  /* padding:20px 0; */
  width: 75vw;
}

.add_course_head {
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 60px;
  /* padding-top: 17px; */
  margin-bottom: 14px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
  border-radius: 8px;
}

.add_course_head img {
  display: block;
  width: 24px;
  height: 20px;
  margin: 20px 0;
  cursor: pointer;
}

.content {
  height: calc(100vh - 240px);
  background: #ffffff;
  padding-top: 10px;
}

.content_box_head {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
  margin: 0px 16px 17px 18px;
  height: 40px;
}

.content_search {
  height: 40px;
}

.content_search>>>.el-input-group__append {
  border-radius: 0 20px 20px 0;
}

.content_search>>>.el-input__inner {
  border-radius: 20px 0 0 20px !important;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 16px !important;
}

.content_search>>>.el-input {
  height: 40px;
}

.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}

.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}

.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.course_creat_sort_options>div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}

.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}

.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}

.color_active {
  color: #ff9b36 !important;
}

.creat_course {
  /* width: 78px; */
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}

.course_list {
  height: calc(100% - 100px);
  margin: 0 16px 0 18px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.course_card {
  height: 300px;
  width: 320px;
  border: 4px solid #69b4ff;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 6px 20px 20px 6px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.teaching_card {
  height: 200px !important;
}

.course_card_title {
  height: 30px;
  line-height: 20px;
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}

.course_card_title_icon img {
  display: block;
}

.course_card_title_name {
  width: 130px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  margin-left: 5px;
  margin-right: 10px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.course_card_content_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.course_card_operation {
  display: flex;
  justify-content: space-between;
}

.course_card_operation_item {
  cursor: pointer;
}

.course_card_operation_item img {
  display: block;
  width: 26px;
  height: 26px;
}

.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}

.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}

.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
}

.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 30px 0;
}

.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}

.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}

.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}

.listBox {
  display: flex;
  flex-direction: column;
  height: calc(75vh - 120px);
  overflow: auto;
}

.listItem {
  border: 1px dashed #333333;
  padding: 20px 10px;
  margin-bottom: 10px;
}

.listItemTitle {
  margin-bottom: 10px;
}

.listItemContent {
  margin-bottom: 10px;
}

.listItemFooter {
  margin-bottom: 20px;
}
</style>
